import script from "./VLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./VLoader.vue?vue&type=script&setup=true&lang=js"

import "./VLoader.vue?vue&type=style&index=0&id=b9c234cc&lang=scss"

const __exports__ = script;

export default __exports__